
import beefShawarma from './Shawarma/Beef Shawarma.png'
import chickenShawarma from './Shawarma/Chicken Shawarma.png'

let shawarmaItems = [
    {
        item_id: "26",
        item_name: "Chicken Shawarma",
        item_image: chickenShawarma ,
        item_price:"1950",
        item_category: "shawarma",
      },
      {
        item_id: "27",
        item_name: "Beef Shawarma",
        item_image:beefShawarma ,
        item_price:"2150",
        item_category: "shawarma",
      },
]

export default shawarmaItems